import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Form } from "./form";

ReactDOM.render(
  <React.StrictMode>
    <Form />
  </React.StrictMode>,
  document.getElementById("root")
);
